import { CurrentUserContext, UserModel } from '@insided/shared/services/UserContext'
import { FunctionalComponent } from 'preact'
import { z } from 'zod'
// eslint-disable-next-line import/no-internal-modules
import { GetServerSideProps } from '../../../../server-middleware/context'

export const widgetName = 'gainsight-px-activation' as const

// the data config
export const config = z.object({
  communityId: z.string(),
  signUpDate: z.number() // is missing in UserContext and was missed in the nodejs implementation
})

export type GainsightPxActivationConfig = z.infer<typeof config>

interface GainsightPxActivationProps {
  communityId: string
  signUpDate: number
}

// the function which allows to alter config and get the context of execution
export const getServerSideProps: GetServerSideProps<GainsightPxActivationConfig, GainsightPxActivationProps> = async (
  _,
  config
) => {
  return config
}

const GainsightPxActivation: FunctionalComponent<GainsightPxActivationProps> = ({ communityId, signUpDate }) => {
  return (
    <CurrentUserContext.Consumer>
      {(user) => {
        if (!user.id) {
          return null
        }
        return (
          <script
            dangerouslySetInnerHTML={{
              __html: createGainsightPxActivationScript(communityId, user, signUpDate)
            }}
          />
        )
      }}
    </CurrentUserContext.Consumer>
  )
}

// default export is the component
export default GainsightPxActivation

const createGainsightPxActivationScript = (communityId: string, user: UserModel, signUpDate: number): string => {
  const userData = {
    id: `${communityId}:${user.id}`,
    userName: user.name,
    product: 'destination',
    signUpDate,
    role: user.mainRole,
    customRoles: user.role,
    replies: user.repliesCount,
    topics: user.topicsCount
  }
  const communityData = {
    id: communityId
  }

  const userArgument = JSON.stringify(userData)
  const communityArgument = JSON.stringify(communityData)

  return `aptrinsic("identify",${userArgument},${communityArgument});`
}
